import { FeatureFlag } from 'api/organizationApi';
import { User } from 'api/userApi';
import { isEarlyAccessFeature, userHasFeatureAccess } from 'models/Role';
import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';
import EarlyAccessBanner from './EarlyAccessBanner';
import AccessDenied from 'views/AccessDenied';

function FeatureFlagWarpper({
  children,
  user,
  featureFlag,
  bannerSx,
}: {
  children: React.ReactNode;
  user: User;
  featureFlag: FeatureFlag;
  /** Extra styles for the early access banner's wrapper, e.g. a top margin. */
  bannerSx?: SxProps<Theme>;
}) {
  if (isEarlyAccessFeature(user, featureFlag)) {
    return (
      <>
        <Box
          sx={[
            { '& > *': { margin: 0, marginBottom: '1rem' } },
            ...(Array.isArray(bannerSx) ? bannerSx : [bannerSx]),
          ]}
        >
          <EarlyAccessBanner />
        </Box>
        {children}
      </>
    );
  }

  if (userHasFeatureAccess(user, featureFlag)) {
    return <>{children}</>;
  }

  return <AccessDenied />;
}

export default FeatureFlagWarpper;
